/* Copyright (c) 2022-present TVM Engineering Authors. */

import types from '../actions/types';

export const INITIAL_STATE = {
	profile: {},
	message: '',
	error: '',
	workers: [],
	users: [],
	selectedUser: '',
	userRoles: [
		{ name: 'User', value: 'user' }
	]
};

export default function adminReducer(state = INITIAL_STATE, action) {
	switch (action.type) {
		case types.FETCH_USER:
			return { ...state, profile: action.payload };
		case types.FETCH_ALL_USERS:
			return { ...state, users: action.payload };
		case types.FETCH_CREATE_USER:
			return { ...state, user: action.payload };
		case types.FETCH_USER_ACTIVATION:
			return { ...state, isActiveUser: action.activated };
		default:
			return state;
	}
}

// Selectors
// export const getUser = (state) => state.admin.profile;
// export const getSelectedUser = (state) => state.admin.selectedUser;
export const getUsers = (state) => {
	const users = state.admin.users;
	// const userID = state.auth.user.user.id;
	// users = users.filter((obj) => {
	// 	return obj.id !== userID;
	// });
	return users;
};
export const getUserRoles = (state) => state.admin.userRoles;
// export const getUserActivation = (state) => state.admin.isActiveUser;
